import { getLocalDate } from '@surfline/web-common';
import { MDY } from 'common/constants';
import { format } from 'date-fns';

export const formatLastModelRunTimestamp = (
  abbrTimezone: string,
  dateFormat: string | undefined,
  lastModelRunTimestamp: number,
  utcOffset: number,
) => {
  const localDate = getLocalDate(lastModelRunTimestamp, utcOffset);
  const utcDate = getLocalDate(lastModelRunTimestamp, 0);
  const localFormatString = dateFormat === MDY ? 'MMM d haaa' : 'd MMM haaa';
  const utcFormatString = dateFormat === MDY ? 'MMM d HH' : 'd MMM HH';
  const transformedLocalDate = `${format(localDate, localFormatString)} ${abbrTimezone} `;
  const transformedUtcDate = `${format(utcDate, utcFormatString)} UTC`;

  return `Model run: ${transformedLocalDate} (${transformedUtcDate})`;
};

export const getInitialDaySelectorStartDay = (
  index: number,
  daysPerRange: number,
  daysAllowed: number,
) => {
  if (index > daysAllowed - daysPerRange) {
    if (daysAllowed >= daysPerRange) return daysAllowed - daysPerRange;
    return 0;
  }

  if (index > 0) return index;

  return 0;
};
